export const PARTNER_CLIENT_BASE_OPTIONS = [
  "1-5 clients",
  "6-15 clients",
  "16-50 clients",
  "51+ clients",
];

export const PARTNER_CLIENT_BASE_SELECT_OPTIONS = [
  { value: "1-5 clients", label: "1–5 clients" },
  { value: "6-15 clients", label: "6–15 clients" },
  { value: "16-50 clients", label: "16–50 clients" },
  { value: "51+ clients", label: "51+ clients" },
];
